import { Component } from 'react';

import { Box, Grid, Stack } from '@mui/material';

import ProjectCard from './ProjectCard';

export default class Projects extends Component {
  getItems() {
    return [
      {
        title: 'Templates',
        link: 'https://gitlab.com/fakinasa/typst-templates-up',
        src: 'img/projects/templates.png',
        description: 'Templates for Multiple Types of Document Generation',
        situation: 'Hobby Project',
        programmingLanguage: 'Typst',
        date: 'Ongoing',
      },
      {
        title: 'PoloWM',
        link: 'https://fakinasa.gitlab.io/polowm/',
        src: 'img/projects/polowm.png',
        description: 'Fast, Lightweight, Minimalist and Flexible Wayland Compositor',
        situation: 'Hobby Project',
        programmingLanguage: 'C++, Wayland',
        date: 'Ongoing',
      },
      {
        title: 'Keyboard Notifier',
        link: 'https://gitlab.com/fakinasa/keyboard_notifier',
        src: 'img/projects/kb_not.png',
        description: 'Watcher over keyboard actions',
        situation: 'Hobby Project',
        programmingLanguage: 'C',
        date: 'Nov 2024',
      },
      {
        title: 'Last-Mile Delivery Problem Representation in Reinforcement Learning',
        link: 'https://hdl.handle.net/10216/151971',
        src: 'img/projects/dissertation.png',
        description: 'Application of TL to RL agents solving the CVRP and CVRPSTW Problems',
        situation: 'My Master\'s Dissertation Project',
        programmingLanguage: 'Python, Pytorch, C++',
        date: 'Jul 2023',
      },
        // Typst Templates UP
        // PoloWM
        // Keyboard Notifier
      {
        title: 'Interactive Satellite Megaconstellation Simulation',
        link: 'https://github.com/LeKinaSa/ms-iscs',
        src: 'img/projects/iscs.png',
        description: 'Simulator for satellite megaconstellations, including failures and inter-satellite link strategies',
        situation: 'Project developed for the "Modelling and Simulation" curricular unit',
        programmingLanguage: 'Rust, Python, Godot',
        date: 'Jan 2023',
      },
      {
        title: 'OXID-8: a CHIP-8 / S-CHIP Emulator',
        link: 'https://github.com/LeKinaSa/s-oxid8',
        src: 'img/projects/oxid.png',
        description: 'Emulator for CHIP-8 and S-CHIP Developed using the Rust Programming Language and the RetroArch framework',
        situation: 'Project developed for the "Seminars" curricular unit',
        programmingLanguage: 'Rust, Retroarch',
        date: 'Jan 2023',
      },
      {
        title: 'Tabular, a Domain Specific Language (DSL)',
        link: 'https://github.com/LeKinaSa/els-tables',
        src: 'img/projects/tabular.png',
        description: 'Tabular data extraction and manipulation, with support for different operations (load, save, merge, concatenate, average, sum, and sort) and file types (JSON, XML, unstructured text)',
        situation: 'Project developed for the "Software Language Engineering" curricular unit',
        programmingLanguage: 'Java, Xtext',
        date: 'Dec 2022',
      },
      {
        title: 'Solver for Capacitated Vehicle Routing Problem',
        link: 'https://github.com/LeKinaSa/edaa-vrp',
        src: 'img/projects/cvrp_solver.png',
        description: 'Data Structures and Algorithms for solving large-scale CVRP instances.',
        situation: 'Project developed for the "Advanced Data Structures and Algorithms" curricular unit',
        programmingLanguage: 'C++',
        date: 'Jul 2022',
      },
      {
        title: 'Forest Fire Simulation',
        link: 'https://github.com/LeKinaSa/asma-forest-fire',
        src: 'img/projects/ff.png',
        description: 'Simple Simulation based on different forest-fire models, including the Drossel & Schwabl one',
        situation: 'Project developed for the "Agents and Multi-Agent Systems" curricular unit',
        programmingLanguage: 'Python (Mesa)',
        date: 'Jun 2022',
      },
      {
        title: 'Factory Line Scheduling',
        link: 'https://github.com/LeKinaSa/plr-job-shop',
        src: 'img/projects/jsp.png',
        description: 'Solver for the Flexible Job Shop Problem with Overtime Constraints',
        situation: 'Project developed for the "Constraint Logic Programming" curricular unit',
        programmingLanguage: 'Python (OR-Tools, DOcplex), Prolog',
        date: 'Jun 2022',
      },
      {
        title: 'Decentralized Message Timeline Service',
        link: 'https://github.com/LeKinaSa/sdle-proj2',
        src: 'img/projects/decentralized_timeline.jpg',
        description: 'Users can subscribe / unsubscribe to other users and publish messages to their own timeline',
        situation: 'Project developed for the "Large-Scale Distributed Systems" curricular unit',
        programmingLanguage: 'Python (Kademlia)',
        date: 'Jan 2022',
      },
      {
        title: 'Unified Search System for Steam Games',
        link: 'https://github.com/LeKinaSa/pri-search-engine',
        src: 'img/projects/steam_search.png',
        description: 'Query and search engine with aggregated Steam data (from public datasets, APIs, and website scraping)',
        situation: 'Project developed for the "Information Processing and Retrieval" curricular unit',
        programmingLanguage: 'Python (Pandas), Solr',
        date: 'Jan 2022',
      },
      {
        title: 'Reliable PUB / SUB Service',
        link: 'https://github.com/LeKinaSa/sdle-proj1',
        src: 'img/projects/pub_sub.png',
        description: 'Publish/Subscribe service implemented using the ZeroMQ library. Several fault tolerance mechanisms in place to ensure exactly-once message delivery (durable subscriptions, crash recovery).',
        situation: 'Project developed for the "Large-Scale Distributed Systems" curricular unit',
        programmingLanguage: 'Python (ZeroMQ)',
        date: 'Nov 2021',
      },
      {
        title: 'Peer-to-Peer Distributed Backup Service',
        link: 'https://github.com/LeKinaSa/sdis-proj2',
        src: 'img/projects/chord.png',
        description: 'Implementation of the Chord distributed hash table protocol (using secure sockets, thread pools, and non-blocking I/O)',
        situation: 'Project developed for the "Distributed Systems" curricular unit',
        programmingLanguage: 'Java',
        date: 'Jun 2021',
      },
      {
        title: 'Tak remake',
        link: 'https://github.com/LeKinaSa/iart-tak',
        src: 'img/projects/tak.png',
        description: '1v1 game inspired in \'Tak\' (includes PvP, PvC and CvC modes with 3 computer difficulties)',
        situation: 'Project developed for the Artificial Intelligence curricular unit',
        programmingLanguage: 'Python',
        date: 'Jun 2021',
      },
      {
        title: 'Java-- Compiler',
        link: 'https://github.com/LeKinaSa/comp-javaminus',
        src: 'img/projects/javaminus.png',
        description: 'Generate an AST detecting syntactic errors, perform semantic analysis to build a symbol table while checking for semantic errors, convert the AST to OLLIR code, apply the specified optimizations, and translate the OLLIR code to Jasmin code to produce a .class file',
        situation: 'Project developed for the "Compilers" curricular unit',
        programmingLanguage: 'Java',
        date: 'May 2021',
      },
      {
        title: 'Talpa Remake',
        link: 'https://github.com/LeKinaSa/laig-talpa/tree/master/TP3',
        src: 'img/projects/talpa.png',
        description: '1v1 game inspired in the \'Talpa\' boardgame (includes PvP, PvC and CvC modes)',
        situation: 'Project developed for the "Graphical Applications Laboratory" and "Logic Programming" curricular units',
        programmingLanguage: 'Prolog and Javascript',
        date: 'Jan 2021',
      },
      {
        title: 'Tricky Triple Puzzle',
        link: 'https://github.com/LeKinaSa/plog-talpa-trickytriple/tree/master/plog-proj2',
        src: 'img/projects/tricky_triple.png',
        description: 'Grid Puzzle whose goal is to fill the each cell with a symbol so that each group of 3 adjacent white cells must contain exactly 2 of one of the symbols',
        situation: 'Project developed for the "Logic Programming" curricular unit',
        programmingLanguage: 'Prolog',
        date: 'Nov 2020',
      },
      {
        title: 'Out of the Breach',
        link: 'https://github.com/LeKinaSa/lpoo-out-of-the-breach',
        src: 'img/projects/breach.png',
        description: '2D singleplayer game inspired in \'Into the Breach\'',
        situation: 'Project developed for the "Object Oriented Programming Laboratory" curricular unit',
        programmingLanguage: 'Java',
        date: 'Jun 2020',
      },
      {
        title: 'Galactic Warfare',
        link: 'https://github.com/LeKinaSa/lcom-galactic-warfare/tree/master/proj',
        src: 'img/projects/galactic.png',
        description: '1v1 top-down shooter inspired in \'Spacewar!\'',
        situation: 'Project developed for the "Computer Laboratory" curricular unit',
        programmingLanguage: 'C',
        date: 'Jan 2020',
      },
      // {
      //   title: 'Minhocada',
      //   link: 'https://github.com/LeKinaSa/Minhocada',
      //   src: 'img/projects/minhocada.png',
      //   gif: 'img/projects/minhocada.gif',
      //   description: 'Multiplayer game (up to 5 players in the same computer) inspired in \'Snake\'',
      //   situation: 'Personal Project',
      //   programmingLanguage: 'Python (Pygame)',
      //   date: 'Aug 2019',
      // },
      // {
      //   title: '',
      //   link: '',
      //   src: '',
      //   gif: '',
      //   description: '',
      //   situation: '',
      //   programmingLanguage: '',
      //   date: '',
      // },
    ];
  }

  render() {
    const items = this.getItems();
    let itemsList = [];
    items.forEach((item, index) => {
      itemsList.push(
        <Grid className='grid-item' key={index} size={{ xs: 12, xl: 6 }} >
          <ProjectCard item={item} />
        </Grid>
      );
    });

    return (
      <Stack>
        <Box className='projects'>
          <Grid container sx={{ width: '100%' }} >
            {itemsList}
          </Grid>
        </Box>
      </Stack>
    );
  }
}
